// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import { ILevelDomainDto } from 'src/app/infrastructure/models/level-domain-dto';
import { IFunctionData, functionData } from 'src/app/features/function/models/function-data';
import { isEmptyObject } from 'src/app/infrastructure/functions/is-empty-object.function';
import { IRoleListDto } from './role-list-dto.g';
import { IRoleDto, roleDto, RoleDto } from './role-dto.g';
import { IFunctionCreditTypeDto } from './function-credit-type-dto.g';

export const functionDto = {
    guid: 'guid',
    nr: 'nr',
    name: 'name',
    displayName: 'displayName',
    isAdmin: 'isAdmin',
    isOwner: 'isOwner',
    appFunction: 'appFunction',
    duFunction: 'duFunction',
    omFunction: 'omFunction',
    default: 'default',
    system: 'system',
    systemDomain: 'systemDomain',
    deleted: 'deleted',
    inactive: 'inactive',
    rolesDto: 'rolesDto',
    creditTypeInfo: 'creditTypeInfo',
} as const;

export type TFunctionDto = (typeof functionDto)[keyof typeof functionDto];

export const functionDtoConstraints = {
    name: { required: true },
} as const;

export type TFunctionDtoConstraints = typeof functionDtoConstraints;

export interface IFunctionDto extends ILevelDomainDto {
    [functionDto.guid]: string | null;
    [functionDto.nr]: number | null;
    [functionDto.name]: string | null;
    [functionDto.displayName]: string | null;
    [functionDto.isAdmin]: boolean | null;
    [functionDto.isOwner]: boolean | null;
    [functionDto.appFunction]: boolean | null;
    [functionDto.duFunction]: boolean | null;
    [functionDto.omFunction]: boolean | null;
    [functionDto.default]: boolean | null;
    [functionDto.system]: boolean | null;
    [functionDto.systemDomain]: boolean | null;
    [functionDto.deleted]: boolean | null;
    [functionDto.inactive]: boolean | null;
    [functionDto.rolesDto]: IRoleDto[] | null;
    [functionDto.creditTypeInfo]: IFunctionCreditTypeDto | null;
}

export class FunctionDto
    implements IFunctionDto
{
    [functionDto.guid]: string | null = null;
    [functionDto.nr]: number | null = null;
    [functionDto.name]: string | null = null;
    [functionDto.displayName]: string | null = null;
    [functionDto.isAdmin]: boolean | null = null;
    [functionDto.isOwner]: boolean | null = null;
    [functionDto.appFunction]: boolean | null = null;
    [functionDto.duFunction]: boolean | null = null;
    [functionDto.omFunction]: boolean | null = null;
    [functionDto.default]: boolean | null = null;
    [functionDto.system]: boolean | null = null;
    [functionDto.systemDomain]: boolean | null = null;
    [functionDto.deleted]: boolean | null = null;
    [functionDto.inactive]: boolean | null = null;
    [functionDto.rolesDto]: IRoleDto[] | null = null;
    [functionDto.creditTypeInfo]: IFunctionCreditTypeDto | null = null;

    private constructor(modelData: IFunctionData, includeRefs = true) {
        if (!modelData || isEmptyObject(modelData)) return;

        this[functionDto.guid] = modelData[functionData.guid];
        this[functionDto.nr] = modelData[functionData.nr];
        this[functionDto.name] = modelData[functionData.name];
        this[functionDto.displayName] = modelData[functionData.displayName];
        this[functionDto.isAdmin] = modelData[functionData.isAdmin];
        this[functionDto.appFunction] = modelData[functionData.appFunction];
        this[functionDto.duFunction] = modelData[functionData.dUFunction];
        this[functionDto.omFunction] = modelData[functionData.oMFunction];
        this[functionDto.default] = modelData[functionData.default];
        this[functionDto.system] = modelData[functionData.system];
        this[functionDto.deleted] = modelData[functionData.deleted];
        this[functionDto.inactive] = modelData[functionData.inactive];
        // Alleen het gewenste CreditType; de backend negeert het zonder claim FunctionEdit/CreditType/Update.
        this[functionDto.creditTypeInfo] = modelData[functionData.creditType_guid]
            ? { creditTypeGuid: modelData[functionData.creditType_guid] } as IFunctionCreditTypeDto
            : null;

        if (!includeRefs) return;

        this[functionDto.rolesDto] = modelData[functionData.rolesData]
            ?.map(item => RoleDto.create(item, false))
            .filter((a): a is IRoleDto => a !== null)
            .sort((a, b) => (a[roleDto.name] ?? '').localeCompare(b[roleDto.name] ?? ''))
            ?? null;
    }

    static create(modelData?: IFunctionData | null, includeRefs = true): IFunctionDto | null {
        return modelData ? new FunctionDto(modelData, includeRefs) : null;
    }
}
